<template>
  <div>
    <b-row class="card-box" style="margin: 0">
      <div class="col-md-6 col-xl-4">
        <div>
          <i
            class="fa fa-info-circle text-muted float-right"
            data-toggle="tooltip"
            data-placement="bottom"
            title
            data-original-title="More Info"
          ></i>
          <h4 class="mt-0 font-16">Well Info</h4>
          <hr />
          <p class="text-muted mb-0">
            Well Name
            <span class="float-right">
              <i class="fa fa-caret-up text-success mr-1"></i>
              <b>{{ currentWell.wellName }}</b>
            </span>
          </p>
          <p class="text-muted mb-0">
            Well Description
            <span class="float-right">
              <i class="fa fa-caret-up text-success mr-1"></i>
              <b>{{ currentWell.wellDesc }}</b>
            </span>
          </p>
          <p class="text-muted mb-0">
            Well Status
            <span class="float-right">
              <i class="fa fa-caret-up text-success mr-1"></i>
              <b>{{ currentWell.wellStatus.statusDesc }}</b>
            </span>
          </p>
        </div>
      </div>

      <div class="col-md-6 col-xl-4">
        <div>
          <i
            class="fa fa-info-circle text-muted float-right"
            data-toggle="tooltip"
            data-placement="bottom"
            title
            data-original-title="More Info"
          ></i>
          <h4 class="mt-0 font-16">&nbsp;</h4>
          <hr />
          <p class="text-muted mb-0">
            Field Name
            <span class="float-right">
              <i class="fa fa-caret-up text-success mr-1"></i>
              <b>{{ currentWell.pad.field.fieldName }}</b>
            </span>
          </p>
          <p class="text-muted mb-0">
            Pad Name
            <span class="float-right">
              <i class="fa fa-caret-up text-success mr-1"></i>
              <b>{{ currentWell.pad.padName }}</b>
            </span>
          </p>

          <p class="text-muted mb-0">
            Spud Date
            <span class="float-right">
              <i class="fa fa-caret-up text-success mr-1"></i>
              <b>{{ currentWell.spudDate.replace('T', ' ') }}</b>
            </span>
          </p>
          <p class="text-muted mb-0">
            &nbsp;
            <span class="float-right">
              <i class="fa fa-caret-up text-success mr-1"></i>
              &nbsp;
            </span>
          </p>
        </div>
      </div>

      <div class="col-md-6 col-xl-4">
        <div>
          <i
            class="fa fa-info-circle text-muted float-right"
            data-toggle="tooltip"
            data-placement="bottom"
            title
            data-original-title="More Info"
          ></i>
          <h4 class="mt-0 font-16">&nbsp;</h4>
          <hr />
          <p class="text-muted mb-0">
            Total Days
            <span class="float-right">
              <i class="fa fa-caret-up text-success mr-1"></i>
              <b>{{ totalDays }}</b> days
            </span>
          </p>
          <p class="text-muted mb-0">
            Total Depth
            <span class="float-right">
              <i class="fa fa-caret-up text-success mr-1"></i>
              <b>{{ currentWell.totalDepth }}</b>
              {{ $t('unit.ft') }}MD
            </span>
          </p>
        </div>
      </div>
    </b-row>
    <br />
  </div>
</template>
<script>
import Vue from 'vue'
import HighchartsVue from 'highcharts-vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { formMethods, authComputed } from '@state/helpers'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.use(HighchartsVue)

export default {
  components: {},
  props: { 
    wellId: {type: Number, default: undefined}, 
    padId: {type: Number, default: undefined}, 
    fieldId: {type: Number, default: undefined} 
  },
  data() {
    return {}
  },
  computed: {
    ...authComputed,
    totalDays() {
      return isNaN(this.currentWell.totalDays) ? this.currentWell.totalDays : this.currentWell.totalDays.toFixed(0)
    }
  },
  watch: {
    fieldId: function (val) {},
    padId: function (val) {},
    wellId: function (val) {},
  },
  created: function () {},
  methods: {
    ...formMethods,
  },
}
</script>